import React, { memo, useEffect } from "react";
import "./HomepageBanner.css";
import HeadingH1 from "../../../utls/HeadingH1";

const Banner = () => {
  const slides = [
    {
      src: "https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Fostering%20connections%20between%20businesses%20and%20Leisure%202.webp",
      heading: "For Corporates Growth",
      subheading: "TRAVEL SOLUTIONS",
      text: "Is business travel holding you back or pushing you forward? Not with our well-curated, cost-efficient corporate travel solutions!",
      link: "/corporate-travel",
      buttonText: "DISCOVER MORE",
    },
    {
      src: "https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Fostering%20connections%20between%20businesses%20and%20Thoughts%20(1).webp",
      heading: "With Inspired Thoughts",
      subheading: "INNOVATIVE GROWTH",
      text: "How do great ideas turn into success? We help businesses find new opportunities and optimize operations to stay ahead in this evolving world.",
      link: "/consultation",
      buttonText: "LEARN HOW",
    },
    {
      src: "https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Fostering%20connections%20between%20businesses%20and%20Leisure%20(2).webp",
      heading: "With Curated Leisure",
      subheading: "BLEISURE TRAVEL",
      text: "Why choose between work and relaxation when you can have both? Let our expertly crafted bleisure travel experiences deliver you amazing leisure moments.",
      link: "/bliesure",
      buttonText: "THERE’S MORE",
    },
    {
      src: "https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Fostering%20connections%20between%20businesses%20and%20Technology.webp",
      heading: "With Tech Solutions",
      subheading: "GLOBAL EXPANSION",
      text: "Expanding your business across borders? Our tech solutions ease logistics, mobility, etc., making global expansion more efficient than ever.",
      link: "/tech-platform",
      buttonText: "EXPLORE MORE",
    },
  ];

  // Preload images 1–3 after component mounts
  useEffect(() => {
    slides.slice(1).forEach(({ src }) => {
      const img = new Image();
      img.src = src;
      img.srcset = `
        ${src}?w=1200 1200w,
        ${src}?w=480 480w
      `;
      img.sizes = "100vw";
    });
  }, []);

  return (
    <div className="banner-section container-fluid p-0" style={{ minHeight: "80%" }}>
      <div
        id="carouselExampleCaptions"
        className="carousel slide banner-visible"
        data-bs-ride="carousel"
        data-bs-interval="2000"
        style={{ width: "100%", height: "80%" }}
      >
        <div className="carousel-indicators carouselIndicators">
          {slides.map((_, i) => (
            <button
              key={i}
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to={i}
              className={i === 0 ? "active" : ""}
              aria-current={i === 0 ? "true" : undefined}
              aria-label={`Slide ${i + 1}`}
            ></button>
          ))}
        </div>

        <div className="carousel-inner">
          {slides.map((item, i) => (
            <div key={i} className={`carousel-item ${i === 0 ? "active" : ""}`}>
              <picture>
                <source
                  media="(max-width: 480px)"
                  srcSet={`${item.src}?w=480`}
                />
                <source
                  media="(min-width: 481px)"
                  srcSet={`${item.src}?w=1200`}
                />
                <img
                  src={item.src}
                  className="d-block w-100"
                  alt={item.subheading}
                  loading={i === 0 ? "eager" : "lazy"}
                  fetchpriority={i === 0 ? "high" : "auto"}
                  style={{ objectFit: "cover", height: "100%" }}
                />
              </picture>
              <div className="carousel-caption bannercarousel text-white mt-xxl-5 pt-xxl-3 mt-1">
                <p className="grotesk-headings mb-1">{item.subheading}</p>
                <HeadingH1 className="banner-headings w-100">{item.heading}</HeadingH1>
                <div className="d-flex common-second-content">
                  <div className="ornge-border"></div>
                  <div className="second-content">{item.text}</div>
                </div>
                <a href={item.link}>
                  <button className="fw-bold btn text-white fs5 text-uppercase">
                    {item.buttonText}
                  </button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default memo(Banner);